import {
  EXPORT_REPORTS,
  EXPORT_REPORTS_ERROR,
  EXPORT_REPORTS_SUCCESS,

  DOWNLOAD_INCOME_STATEMENT_REPORT,
  DOWNLOAD_INCOME_STATEMENT_REPORT_ERROR,
  DOWNLOAD_INCOME_STATEMENT_REPORT_SUCCESS,

  DOWNLOAD_GL_REPORT,
  DOWNLOAD_GL_REPORT_ERROR,
  DOWNLOAD_GL_REPORT_SUCCESS,

  DOWNLOAD_BALANCE_SHEET_REPORT,
  DOWNLOAD_BALANCE_SHEET_REPORT_ERROR,
  DOWNLOAD_BALANCE_SHEET_REPORT_SUCCESS,

  GET_GL,
  GET_GL_ERROR,
  GET_GL_SUCCESS,

  GET_BALANCE_SHEET,
  GET_BALANCE_SHEET_ERROR,
  GET_BALANCE_SHEET_SUCCESS,

  GET_SOI,
  GET_SOI_ERROR,
  GET_SOI_SUCCESS,

  GET_DRD,
  GET_DRD_ERROR,
  GET_DRD_SUCCESS,

  DRD_DOWNLOAD,
  DRD_DOWNLOAD_ERROR,
  DRD_DOWNLOAD_SUCCESS,

  DRD_DOWNLOAD_PDF,
  DRD_DOWNLOAD_PDF_ERROR,
  DRD_DOWNLOAD_PDF_SUCCESS,

  DRD_EXPORT_PDF,
  DRD_EXPORT_PDF_ERROR,
  DRD_EXPORT_PDF_SUCCESS,

  UPDATE_AMOUNT,
  UPDATE_ACCOUNT,
  UPDATE_INSTITUTE,
  UPDATE_COMMON_CHARGE,
  UPDATE_SHARE,
  UPDATE_DRD,

  EXPORT_COOWNER_SECTION,
  EXPORT_COOWNER_SECTION_ERROR,
  EXPORT_COOWNER_SECTION_SUCCESS,
} from './constants';

export default {
  [EXPORT_REPORTS](state) {
    state.reportLink = '';
    state.success = false;
    state.error = false;
    state.exportLoading = true;
  },
  [EXPORT_REPORTS_ERROR](state, payload) {
    state.error = payload;
    state.exportLoading = false;
  },
  [EXPORT_REPORTS_SUCCESS](state, payload) {
    state.reportLink = payload;
    state.success = true;
    state.exportLoading = false;
  },

  [EXPORT_COOWNER_SECTION](state) {
    state.coownerSectionLink = '';
    state.success = false;
    state.error = false;
    state.exportLoading = true;
  },
  [EXPORT_COOWNER_SECTION_ERROR](state, payload) {
    state.error = payload;
    state.exportLoading = false;
  },
  [EXPORT_COOWNER_SECTION_SUCCESS](state, payload) {
    state.coownerSectionLink = payload;
    state.success = true;
    state.exportLoading = false;
  },

  [DOWNLOAD_INCOME_STATEMENT_REPORT](state) {
    state.downloadIncStmtLink = '';
    state.success = false;
    state.error = false;
    state.exportLoading = true;
  },
  [DOWNLOAD_INCOME_STATEMENT_REPORT_ERROR](state, payload) {
    state.error = payload;
    state.exportLoading = false;
  },
  [DOWNLOAD_INCOME_STATEMENT_REPORT_SUCCESS](state, payload) {
    state.downloadIncStmtLink = payload;
    state.exportLoading = false;
    state.success = true;
  },

  [DOWNLOAD_BALANCE_SHEET_REPORT](state) {
    state.downloadBalanceSheetLink = '';
    state.success = false;
    state.error = false;
    state.exportLoading = true;
  },
  [DOWNLOAD_BALANCE_SHEET_REPORT_ERROR](state, payload) {
    state.error = payload;
    state.exportLoading = false;
  },
  [DOWNLOAD_BALANCE_SHEET_REPORT_SUCCESS](state, payload) {
    state.downloadBalanceSheetLink = payload;
    state.exportLoading = false;
    state.success = true;
  },

  [DOWNLOAD_GL_REPORT](state) {
    state.downloadGLLink = '';
    state.success = false;
    state.error = false;
    state.exportLoading = true;
  },
  [DOWNLOAD_GL_REPORT_ERROR](state, payload) {
    state.error = payload;
    state.exportLoading = false;
  },
  [DOWNLOAD_GL_REPORT_SUCCESS](state, payload) {
    state.downloadGLLink = payload;
    state.exportLoading = false;
    state.success = false;
  },

  [GET_GL](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [GET_GL_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_GL_SUCCESS](state, payload) {
    state.generalLedger = payload;
    state.success = true;
    state.loading = false;
  },

  [GET_BALANCE_SHEET](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [GET_BALANCE_SHEET_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_BALANCE_SHEET_SUCCESS](state, payload) {
    state.balanceSheet = payload;
    state.success = true;
    state.loading = false;
  },

  [GET_SOI](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [GET_SOI_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_SOI_SUCCESS](state, payload) {
    state.soi = payload;
    state.success = true;
    state.loading = false;
  },

  [GET_DRD](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [GET_DRD_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_DRD_SUCCESS](state, payload) {
    state.drd = payload;

    // Define the parseUnit function
    const parseUnit = (unit) => {
      // Check if the unit is undefined or null, return default values
      if (!unit) {
        return {
          prefix: '',
          number: null,
          letter: '',
          hasHyphen: false,
          suffixNumber: null,
          isNumeric: false,
        };
      }

      // Normalize the unit by removing spaces but keeping the hyphen for sorting
      const normalizedUnit = unit.replace(/\s+/g, '');

      // Match alphanumeric structure with or without hyphens
      const match = normalizedUnit.match(/^([A-Za-z\s]*)(\d*)(-?)([A-Za-z]*)(\d*)$/);
      return {
        prefix: match[1] ? match[1].trim() : '',
        number: match[2] ? parseInt(match[2], 10) : null,
        hasHyphen: match[3] === '-',
        letter: match[4] || '',
        suffixNumber: match[5] ? parseInt(match[5], 10) : null,
        isNumeric: /^\d/.test(normalizedUnit),
      };
    };

    // Sort the Payers based on the parsed unit
    state.drd.Payers.sort((a, b) => {
      const unitA = parseUnit(a.Unit);
      const unitB = parseUnit(b.Unit);

      // Step 1: Handle purely numeric or hyphenated comparisons
      const isNumericA = unitA.prefix === '' && unitA.number !== null;
      const isNumericB = unitB.prefix === '' && unitB.number !== null;

      if (isNumericA && isNumericB) {
        if (unitA.hasHyphen !== unitB.hasHyphen) {
          return unitA.hasHyphen ? -1 : 1; // Prioritize hyphenated units
        }
        return unitA.number - unitB.number; // Compare the numeric part
      }
      if (isNumericA) return -1;
      if (isNumericB) return 1;

      const prefixComparison = unitA.prefix.localeCompare(unitB.prefix);
      if (prefixComparison !== 0) return prefixComparison;

      // Step 3: Compare numeric part if both units have a prefix
      if (unitA.number !== unitB.number) {
        return (unitA.number || 0) - (unitB.number || 0);
      }

      const letterComparison = unitA.letter.localeCompare(unitB.letter);
      if (letterComparison !== 0) return letterComparison;

      if (unitA.suffixNumber !== unitB.suffixNumber) {
        return (unitA.suffixNumber || 0) - (unitB.suffixNumber || 0);
      }

      return 0; // Default return if all parts are equal
    });

    // Update success and loading state
    state.success = true;
    state.loading = false;
  },

  [DRD_DOWNLOAD](state) {
    state.drdLink = '';
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DRD_DOWNLOAD_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DRD_DOWNLOAD_SUCCESS](state, payload) {
    state.drdLink = payload;
    state.success = true;
    state.loading = false;
  },

  [DRD_DOWNLOAD_PDF](state) {
    state.drdLink = '';
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DRD_DOWNLOAD_PDF_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DRD_DOWNLOAD_PDF_SUCCESS](state, payload) {
    state.drdLink = payload;
    state.success = true;
    state.loading = false;
  },

  [DRD_EXPORT_PDF](state) {
    state.drdExportLink = '';
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DRD_EXPORT_PDF_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DRD_EXPORT_PDF_SUCCESS](state, payload) {
    state.drdExportLink = payload;
    state.success = true;
    state.loading = false;
  },
  [UPDATE_AMOUNT](state, payload) {
    state.drd.Payers[payload.index].Adjustment = payload.value;
    const parseUnit = (unit) => {
      // Check if the unit is undefined or null, return default values
      if (!unit) {
        return {
          prefix: '',
          number: null,
          letter: '',
          hasHyphen: false,
          suffixNumber: null,
          isNumeric: false,
        };
      }

      // Normalize the unit by removing spaces but keeping the hyphen for sorting
      const normalizedUnit = unit.replace(/\s+/g, '');
      const match = normalizedUnit.match(/^([A-Za-z\s]*)(\d*)(-?)([A-Za-z]*)(\d*)$/);
      if (!match) {
        return {
          prefix: '',
          number: null,
          letter: '',
          hasHyphen: false,
          suffixNumber: null,
          isNumeric: false,
        };
      }
      return {
        prefix: match[1] ? match[1].trim() : '',
        number: match[2] ? parseInt(match[2], 10) : null,
        hasHyphen: match[3] === '-',
        letter: match[4] || '',
        suffixNumber: match[5] ? parseInt(match[5], 10) : null,
        isNumeric: /^\d/.test(normalizedUnit),
      };
    };

    // Sort the Payers based on the parsed unit
    state.drd.Payers.sort((a, b) => {
      const unitA = parseUnit(a.Unit);
      const unitB = parseUnit(b.Unit);

      // Step 1: Handle purely numeric or hyphenated comparisons
      const isNumericA = unitA.prefix === '' && unitA.number !== null;
      const isNumericB = unitB.prefix === '' && unitB.number !== null;

      if (isNumericA && isNumericB) {
        if (unitA.hasHyphen !== unitB.hasHyphen) {
          return unitA.hasHyphen ? -1 : 1; // Prioritize hyphenated units
        }
        return unitA.number - unitB.number; // Compare the numeric part
      }
      if (isNumericA) return -1;
      if (isNumericB) return 1;

      // Step 2: Compare alphabetic prefix (e.g., 'Bruxceel' vs '85')
      const prefixComparison = unitA.prefix.localeCompare(unitB.prefix);
      if (prefixComparison !== 0) return prefixComparison;

      // Step 3: Compare numeric part if both units have a prefix
      if (unitA.number !== unitB.number) {
        return (unitA.number || 0) - (unitB.number || 0);
      }

      // Step 4: Compare the letter part (e.g., '85A' vs '85B')
      const letterComparison = unitA.letter.localeCompare(unitB.letter);
      if (letterComparison !== 0) return letterComparison;

      // Step 5: Compare suffix numbers (e.g., '85-1' vs '85-2')
      if (unitA.suffixNumber !== unitB.suffixNumber) {
        return (unitA.suffixNumber || 0) - (unitB.suffixNumber || 0);
      }

      return 0; // Default return if all parts are equal
    });
  },
  [UPDATE_SHARE](state, payload) {
    state.drd.Payers[payload.index].Share = payload.value;
    const parseUnit = (unit) => {
      // Check if the unit is undefined or null, return default values
      if (!unit) {
        return {
          prefix: '',
          number: null,
          letter: '',
          hasHyphen: false,
          suffixNumber: null,
          isNumeric: false,
        };
      }

      // Normalize the unit by removing spaces but keeping the hyphen for sorting
      const normalizedUnit = unit.replace(/\s+/g, '');

      // Match alphanumeric structure with or without hyphens
      const match = normalizedUnit.match(/^([A-Za-z\s]*)(\d*)(-?)([A-Za-z]*)(\d*)$/);
      if (!match) {
        return {
          prefix: '',
          number: null,
          letter: '',
          hasHyphen: false,
          suffixNumber: null,
          isNumeric: false,
        };
      }
      return {
        prefix: match[1] ? match[1].trim() : '',
        number: match[2] ? parseInt(match[2], 10) : null,
        hasHyphen: match[3] === '-',
        letter: match[4] || '',
        suffixNumber: match[5] ? parseInt(match[5], 10) : null,
        isNumeric: /^\d/.test(normalizedUnit),
      };
    };

    // Sort the Payers based on the parsed unit
    state.drd.Payers.sort((a, b) => {
      const unitA = parseUnit(a.Unit);
      const unitB = parseUnit(b.Unit);

      // Step 1: Handle purely numeric or hyphenated comparisons
      const isNumericA = unitA.prefix === '' && unitA.number !== null;
      const isNumericB = unitB.prefix === '' && unitB.number !== null;

      if (isNumericA && isNumericB) {
        if (unitA.hasHyphen !== unitB.hasHyphen) {
          return unitA.hasHyphen ? -1 : 1; // Prioritize hyphenated units
        }
        return unitA.number - unitB.number; // Compare the numeric part
      }
      if (isNumericA) return -1;
      if (isNumericB) return 1;

      // Step 2: Compare alphabetic prefix (e.g., 'Bruxceel' vs '85')
      const prefixComparison = unitA.prefix.localeCompare(unitB.prefix);
      if (prefixComparison !== 0) return prefixComparison;

      // Step 3: Compare numeric part if both units have a prefix
      if (unitA.number !== unitB.number) {
        return (unitA.number || 0) - (unitB.number || 0);
      }

      // Step 4: Compare the letter part (e.g., '85A' vs '85B')
      const letterComparison = unitA.letter.localeCompare(unitB.letter);
      if (letterComparison !== 0) return letterComparison;

      // Step 5: Compare suffix numbers (e.g., '85-1' vs '85-2')
      if (unitA.suffixNumber !== unitB.suffixNumber) {
        return (unitA.suffixNumber || 0) - (unitB.suffixNumber || 0);
      }

      return 0; // Default return if all parts are equal
    });
  },
  [UPDATE_DRD](state, payload) {
    state.drd.Payers[payload.index].Drd = payload.value;
    const parseUnit = (unit) => {
      // Check if the unit is undefined or null, return default values
      if (!unit) {
        return {
          prefix: '',
          number: null,
          letter: '',
          hasHyphen: false,
          suffixNumber: null,
          isNumeric: false,
        };
      }

      // Normalize the unit by removing spaces but keeping the hyphen for sorting
      const normalizedUnit = unit.replace(/\s+/g, '');

      // Match alphanumeric structure with or without hyphens
      const match = normalizedUnit.match(/^([A-Za-z\s]*)(\d*)(-?)([A-Za-z]*)(\d*)$/);
      if (!match) {
        return {
          prefix: '',
          number: null,
          letter: '',
          hasHyphen: false,
          suffixNumber: null,
          isNumeric: false,
        };
      }
      return {
        prefix: match[1] ? match[1].trim() : '',
        number: match[2] ? parseInt(match[2], 10) : null,
        hasHyphen: match[3] === '-',
        letter: match[4] || '',
        suffixNumber: match[5] ? parseInt(match[5], 10) : null,
        isNumeric: /^\d/.test(normalizedUnit),
      };
    };

    // Sort the Payers based on the parsed unit
    state.drd.Payers.sort((a, b) => {
      const unitA = parseUnit(a.Unit);
      const unitB = parseUnit(b.Unit);

      // Step 1: Handle purely numeric or hyphenated comparisons
      const isNumericA = unitA.prefix === '' && unitA.number !== null;
      const isNumericB = unitB.prefix === '' && unitB.number !== null;

      if (isNumericA && isNumericB) {
        if (unitA.hasHyphen !== unitB.hasHyphen) {
          return unitA.hasHyphen ? -1 : 1; // Prioritize hyphenated units
        }
        return unitA.number - unitB.number; // Compare the numeric part
      }
      if (isNumericA) return -1;
      if (isNumericB) return 1;

      // Step 2: Compare alphabetic prefix (e.g., 'Bruxceel' vs '85')
      const prefixComparison = unitA.prefix.localeCompare(unitB.prefix);
      if (prefixComparison !== 0) return prefixComparison;

      // Step 3: Compare numeric part if both units have a prefix
      if (unitA.number !== unitB.number) {
        return (unitA.number || 0) - (unitB.number || 0);
      }

      // Step 4: Compare the letter part (e.g., '85A' vs '85B')
      const letterComparison = unitA.letter.localeCompare(unitB.letter);
      if (letterComparison !== 0) return letterComparison;

      // Step 5: Compare suffix numbers (e.g., '85-1' vs '85-2')
      if (unitA.suffixNumber !== unitB.suffixNumber) {
        return (unitA.suffixNumber || 0) - (unitB.suffixNumber || 0);
      }

      return 0; // Default return if all parts are equal
    });
  },
  [UPDATE_ACCOUNT](state, payload) {
    state.drd.Payers[payload.index].AccountNumber = payload.value;
    const parseUnit = (unit) => {
      // Check if the unit is undefined or null, return default values
      if (!unit) {
        return {
          prefix: '',
          number: null,
          letter: '',
          hasHyphen: false,
          suffixNumber: null,
          isNumeric: false,
        };
      }

      // Normalize the unit by removing spaces but keeping the hyphen for sorting
      const normalizedUnit = unit.replace(/\s+/g, '');

      // Match alphanumeric structure with or without hyphens
      const match = normalizedUnit.match(/^([A-Za-z\s]*)(\d*)(-?)([A-Za-z]*)(\d*)$/);
      if (!match) {
        return {
          prefix: '',
          number: null,
          letter: '',
          hasHyphen: false,
          suffixNumber: null,
          isNumeric: false,
        };
      }
      return {
        prefix: match[1] ? match[1].trim() : '',
        number: match[2] ? parseInt(match[2], 10) : null,
        hasHyphen: match[3] === '-',
        letter: match[4] || '',
        suffixNumber: match[5] ? parseInt(match[5], 10) : null,
        isNumeric: /^\d/.test(normalizedUnit),
      };
    };

    // Sort the Payers based on the parsed unit
    state.drd.Payers.sort((a, b) => {
      const unitA = parseUnit(a.Unit);
      const unitB = parseUnit(b.Unit);

      // Step 1: Handle purely numeric or hyphenated comparisons
      const isNumericA = unitA.prefix === '' && unitA.number !== null;
      const isNumericB = unitB.prefix === '' && unitB.number !== null;

      if (isNumericA && isNumericB) {
        if (unitA.hasHyphen !== unitB.hasHyphen) {
          return unitA.hasHyphen ? -1 : 1; // Prioritize hyphenated units
        }
        return unitA.number - unitB.number; // Compare the numeric part
      }
      if (isNumericA) return -1;
      if (isNumericB) return 1;

      // Step 2: Compare alphabetic prefix (e.g., 'Bruxceel' vs '85')
      const prefixComparison = unitA.prefix.localeCompare(unitB.prefix);
      if (prefixComparison !== 0) return prefixComparison;

      // Step 3: Compare numeric part if both units have a prefix
      if (unitA.number !== unitB.number) {
        return (unitA.number || 0) - (unitB.number || 0);
      }

      // Step 4: Compare the letter part (e.g., '85A' vs '85B')
      const letterComparison = unitA.letter.localeCompare(unitB.letter);
      if (letterComparison !== 0) return letterComparison;

      // Step 5: Compare suffix numbers (e.g., '85-1' vs '85-2')
      if (unitA.suffixNumber !== unitB.suffixNumber) {
        return (unitA.suffixNumber || 0) - (unitB.suffixNumber || 0);
      }

      return 0; // Default return if all parts are equal
    });
  },
  [UPDATE_INSTITUTE](state, payload) {
    state.drd.Payers[payload.index].InstitutionNumber = payload.value;

    const parseUnit = (unit) => {
      // Check if the unit is undefined or null, return default values
      if (!unit) {
        return {
          prefix: '',
          number: null,
          letter: '',
          hasHyphen: false,
          suffixNumber: null,
          isNumeric: false,
        };
      }

      // Normalize the unit by removing spaces but keeping the hyphen for sorting
      const normalizedUnit = unit.replace(/\s+/g, '');

      // Match alphanumeric structure with or without hyphens
      const match = normalizedUnit.match(/^([A-Za-z\s]*)(\d*)(-?)([A-Za-z]*)(\d*)$/);
      if (!match) {
        return {
          prefix: '',
          number: null,
          letter: '',
          hasHyphen: false,
          suffixNumber: null,
          isNumeric: false,
        };
      }
      return {
        prefix: match[1] ? match[1].trim() : '',
        number: match[2] ? parseInt(match[2], 10) : null,
        hasHyphen: match[3] === '-',
        letter: match[4] || '',
        suffixNumber: match[5] ? parseInt(match[5], 10) : null,
        isNumeric: /^\d/.test(normalizedUnit),
      };
    };

    // Sort the Payers based on the parsed unit
    state.drd.Payers.sort((a, b) => {
      const unitA = parseUnit(a.Unit);
      const unitB = parseUnit(b.Unit);

      // Step 1: Handle purely numeric or hyphenated comparisons
      const isNumericA = unitA.prefix === '' && unitA.number !== null;
      const isNumericB = unitB.prefix === '' && unitB.number !== null;

      if (isNumericA && isNumericB) {
        if (unitA.hasHyphen !== unitB.hasHyphen) {
          return unitA.hasHyphen ? -1 : 1; // Prioritize hyphenated units
        }
        return unitA.number - unitB.number; // Compare the numeric part
      }
      if (isNumericA) return -1;
      if (isNumericB) return 1;

      // Step 2: Compare alphabetic prefix (e.g., 'Bruxceel' vs '85')
      const prefixComparison = unitA.prefix.localeCompare(unitB.prefix);
      if (prefixComparison !== 0) return prefixComparison;

      // Step 3: Compare numeric part if both units have a prefix
      if (unitA.number !== unitB.number) {
        return (unitA.number || 0) - (unitB.number || 0);
      }

      // Step 4: Compare the letter part (e.g., '85A' vs '85B')
      const letterComparison = unitA.letter.localeCompare(unitB.letter);
      if (letterComparison !== 0) return letterComparison;

      // Step 5: Compare suffix numbers (e.g., '85-1' vs '85-2')
      if (unitA.suffixNumber !== unitB.suffixNumber) {
        return (unitA.suffixNumber || 0) - (unitB.suffixNumber || 0);
      }

      return 0; // Default return if all parts are equal
    });
  },

  [UPDATE_COMMON_CHARGE](state, payload) {
    state.drd = payload;
  },

  // single object item mutation
  updateItem(state, payload) {
    state.drd[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Reports/mutations.js